var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/hrgs/master/SchemaEnum';
import ApiService from '@/core/services/ApiService';
import { ElMessage } from 'element-plus';
import { ISchemaForm } from '@/core/types/entities/hrgs/master/SchemaEntities';
import { Pagination } from '@/core/enums/Pagination';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/schemes`,
    schemeanswertype: `${API_URL}/api/schemeanswertype`
};
let SchemaModule = class SchemaModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.schemaList = [];
        this.loading = false;
        this.schemaListPagination = [];
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1
        };
        this.filter = {
            code: '',
            title: ''
        };
        this.orderBy = null;
    }
    // *GETTERS
    get getSchemaList() {
        return this.schemaList;
    }
    get getSchemaListLoading() {
        return this.loading;
    }
    get getSchemaListFilter() {
        return this.filter;
    }
    get getSchemaListPagination() {
        return this.pagination;
    }
    // *MUTATIONS
    [_a = Mutations.SET_SCHEMA_LIST](data) {
        this.schemaList = data;
    }
    [_b = Mutations.SET_SCHEMA_LIST_LOADING](data) {
        this.loading = data;
    }
    [_c = Mutations.SET_SCHEMA_LIST_FILTER](data) {
        this.filter = Object.assign(Object.assign({}, this.filter), data);
    }
    [_d = Mutations.RESET_SCHEMA_LIST_FILTER]() {
        this.filter = {
            code: '',
            title: ''
        };
    }
    [_e = Mutations.SET_SCHEMA_LIST_PAGINATION](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize)
        };
    }
    [_f = Mutations.SET_ORDER](data) {
        this.orderBy = data;
    }
    // *start: ACTION
    [_g = Actions.GET_LIST](payload) {
        var _w, _x;
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const filter = `SearchValues=${((_w = this.filter) === null || _w === void 0 ? void 0 : _w.code) || ''}&SearchValues=${((_x = this.filter) === null || _x === void 0 ? void 0 : _x.title) || ''}`;
        const params = Object.assign(Object.assign({ ver: 'v1', pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO }, ((payload === null || payload === void 0 ? void 0 : payload.positionId) && {
            positionId: payload.positionId
        })), (this.orderBy && {
            orderBy: this.orderBy
        }));
        this.context.commit(Mutations.SET_SCHEMA_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}?${filter}&${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_SCHEMA_LIST, resData.data);
                this.context.commit(Mutations.SET_SCHEMA_LIST_PAGINATION, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: resData.totalRecords
                });
                resolve(resData.data);
            })
                .catch((error) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed get schema list.' });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_SCHEMA_LIST_LOADING, false);
            });
        });
    }
    [_h = Actions.GET_DETAIL](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const data = response.data.result.content;
                resolve(data);
            })
                .catch((error) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed get schema details.' });
                reject(error);
            });
        });
    }
    [_j = Actions.GET_ANSWER_TYPE_BY_DETAIL](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const url = `${API_URLS.url}/${employeeID}/${payload.schemaID}/answerTypes?`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                resolve(data.data.result.content);
            })
                .catch((error) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed get answer type.' });
                reject(error);
            });
        });
    }
    [_k = Actions.POST_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload;
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    this.context.commit(Mutations.RESET_SCHEMA_LIST_FILTER);
                    this.context.dispatch(Actions.GET_LIST);
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed create schema.' });
                reject(_response);
            });
        });
    }
    [_l = Actions.UPDATE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload.data;
        return new Promise((resolve, reject) => {
            ApiService.put(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    this.context.commit(Mutations.RESET_SCHEMA_LIST_FILTER);
                    this.context.dispatch(Actions.GET_LIST);
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed update schema.' });
                reject(_response);
            });
        });
    }
    [_m = Actions.DELETE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else {
                    this.context.commit(Mutations.RESET_SCHEMA_LIST_FILTER);
                    this.context.dispatch(Actions.GET_LIST);
                    resolve(res.data.statusCode);
                }
            })
                .catch((response) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed delete schema.' });
                reject(response);
            });
        });
    }
    [_o = Actions.CREATE_EXPORT]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.schemeanswertype}/${employeeID}/exportcreate?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_p = Actions.CHANGE_EXPORT]() {
        var _w, _x;
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const filter = `SearchValues=${((_w = this.filter) === null || _w === void 0 ? void 0 : _w.code) || ''}&SearchValues=${((_x = this.filter) === null || _x === void 0 ? void 0 : _x.title) || ''}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.schemeanswertype}/${employeeID}/exportchange?${filter}&${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_q = Actions.DOWNLOAD](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            fileName: (payload === null || payload === void 0 ? void 0 : payload.fileName) || ''
        };
        return new Promise((resolve, reject) => {
            ApiService.getBlob(`${API_URLS.schemeanswertype}/${employeeID}/download?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', params.fileName);
                document.body.appendChild(link);
                link.click();
                resolve();
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_r = Actions.UPLOAD_CHANGE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = new FormData();
        formdata.append('fileUpload', payload.fileUpload);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.schemeanswertype}/${employeeID}/changeupload?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed upload change schema.'
                });
                reject(_response);
            });
        });
    }
    [_s = Actions.UPLOAD_SUBMIT_CHANGE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            request: payload.data
        };
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.schemeanswertype}/${employeeID}/changeupload/submit?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed submit upload change schema.'
                });
                reject(_response);
            });
        });
    }
    [_t = Actions.UPLOAD_CREATE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = new FormData();
        formdata.append('fileUpload', payload.fileUpload);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.schemeanswertype}/${employeeID}/createupload?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed upload create schema.'
                });
                reject(_response);
            });
        });
    }
    [_u = Actions.UPLOAD_SUBMIT_CREATE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            request: payload.data
        };
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.schemeanswertype}/${employeeID}/createupload/submit?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed submit upload create schema.'
                });
                reject(_response);
            });
        });
    }
    [_v = Actions.GET_COMPETENCY_BY_SCHEMA_ANSWERTYPE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const url = `${API_URLS.url}/${employeeID}/${payload.schemaID}/answerTypes/${payload.answerTypeId}/competencyUnits?`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${url}${new URLSearchParams(params).toString() || ''}`)
                .then((data) => {
                const resData = data.data.result.content;
                resolve(resData);
            })
                .catch(() => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed get competency unit.' });
                reject();
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _f, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _g, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _h, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _j, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_w = typeof ISchemaForm !== "undefined" && ISchemaForm) === "function" ? _w : Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _k, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _l, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _m, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _o, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _p, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _q, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _r, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _s, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _t, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _u, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], SchemaModule.prototype, _v, null);
SchemaModule = __decorate([
    Module
], SchemaModule);
export default SchemaModule;
